import { render, staticRenderFns } from "./Head.vue?vue&type=template&id=76c7ca12&scoped=true&lang=pug"
import script from "./Head.vue?vue&type=script&lang=js"
export * from "./Head.vue?vue&type=script&lang=js"
import style0 from "./Head.vue?vue&type=style&index=0&id=76c7ca12&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c7ca12",
  null
  
)

export default component.exports